import React, { useEffect, useState } from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";

const LoadingMaster = (props) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const onStart = () => {
    if (!loading) {
      setLoading(true);
    }
  };

  const onDone = () => {
    if (loading) {
      setLoading(false);
    }
  };

  const onError = () => {
    if (loading) {
      setLoading(false);
    }
  };

  // Router.events.on('routeChangeStart', onStart);
  // Router.events.on('routeChangeError', onError);
  // Router.events.on('routeChangeComplete', onDone);

  useEffect(() => {
    return () => {
      // Router.events.off('routeChangeStart', onStart);
      // Router.events.off('routeChangeError', onDone);
      // Router.events.off('routeChangeComplete', onDone);
    };
  });

  return (
    <Wrapper>
      {loading ? (
        <Wrapper>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              zIndex: 2000,
            }}
          >
            {/*<LinearProgress variant={"determinate"} value={progress}/>*/}
          </div>
        </Wrapper>
      ) : (
        ""
      )}
    </Wrapper>
  );
};

export default LoadingMaster;
